import React from 'react';
import { SvgIcon, Typography } from '@mui/material';
import { ReactComponent as HelpIcon } from 'mui/assets/icons/help.svg';
import { ReactComponent as PhoneIcon } from 'mui/assets/icons/phone-icon-24.svg';
import { ReactComponent as ChatIcon } from 'mui/assets/icons/chat-bubble.svg';
import Link from '../../../../elements/Link';
import { StyledContactMenu } from './styles';

const DS_FooterContactMenu = ({ items }) => {
  const getContactOptIcon = (url, index) => {
    if (url.includes('zendesk')) return ChatIcon;
    else if (url.includes('tel:')) return PhoneIcon;
    else if (url.includes('faq')) return HelpIcon;
    else return (index === 0 && HelpIcon) || (index === 1 && ChatIcon) || (index === 2 && PhoneIcon);
  };

  return (
    <StyledContactMenu>
      {items.map((item, index) => (
        <Typography
          component={Link}
          key={`${item.id}-${index}`}
          variant="DS_copySmallBold"
          url={item.url}
          type={item.type}
        >
          <SvgIcon component={getContactOptIcon(item.url, index)} inheritViewBox={true} />
          <span>{item.title}</span>
        </Typography>
      ))}
    </StyledContactMenu>
  );
};

export default DS_FooterContactMenu;
